<template>
    <div :class="isMobile ? 'text-center' : ''">
        <SelectCreditsDropdown
            v-if="isMobile"
            :selectable-credits="selectableCredits"
            :disabled="disabled"
            v-model="selectedCredits"
        >
            <template v-slot:labelText>
                {{ translate('Credits') }}
                <i
                    class="fa fa-question-circle text-info cursor-pointer"
                    @click.stop.prevent="learnMore = !learnMore"
                ></i
                >:
                <br />
            </template>
        </SelectCreditsDropdown>

        <SelectCreditsSlider
            v-else-if="!isMobile"
            :selectable-credits="selectableCredits"
            :disabled="disabled"
            v-model="selectedCredits"
        >
            <template v-slot:labelText>
                {{ translate('Credits') }}
                <i
                    class="fa fa-question-circle text-info cursor-pointer"
                    @click.stop.prevent="learnMore = !learnMore"
                ></i
                >:
            </template>
        </SelectCreditsSlider>

        <Transition name="fade-grow">
            <div class="border px-4 py-3 mb-4 bg-white rounded position-relative mt-3" v-if="learnMore">
                <span
                    class="position-absolute top-0 right-0 pt-2 font-size-150 cursor-pointer lh-1 pr-1"
                    @click.stop.prevent="learnMore = false"
                    >&times;</span
                >
                <p>
                    {{
                    translate('Extend your Credits included in your subscription and continue to use certain premium tasks.')
                    }}
                </p>
            </div>
        </Transition>
    </div>
</template>

<script>
import SelectCreditsSlider from './SelectCreditsSlider';
import SelectCreditsDropdown from './SelectCreditsDropdown';
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { pageStoreMixin } from '../../../../store/page-store';
import { testIsNonEmptyString } from '../../../../../lib/test-and-assert/test-base';

export default {
    name: 'SelectCredits',
    components: { SelectCreditsDropdown, SelectCreditsSlider },
    mixins: [TransFilter, pageStoreMixin],
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    beforeMount() {
        this.checkIfMobile();
        window.addEventListener('resize', this.checkIfMobile);

        this.selectableCredits = this.getSelectableCredits();

        if (testIsNonEmptyString(this.selectedCreditsStore)) {
            this.selectedCredits = this.selectedCreditsStore;
        }
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.checkIfMobile);
    },
    watch: {
        selectedCredits(credits) {
            this.store.userPaymentModal.setSelectedSize(credits);
        },
        selectedCreditsStore(credits) {
            if (this.selectedCredits !== credits) {
                this.selectedCredits = credits;
            }
        },
    },
    computed: {
        selectedCreditsStore() {
            return this.store.userPaymentModal.selectedSize;
        },
    },
    methods: {
        checkIfMobile() {
            this.isMobile = window.matchMedia('(max-width: 500px)').matches;
        },
        getSelectableCredits() {
            const creditsValues = [
                '250',
                '500',
                '1000',
                '2000',
                '5000',
            ];

            const selectable = {};

            creditsValues.forEach((credit) => {
                selectable[credit] = this.getFormattedCredits(credit);
            });

            return selectable;
        },
        getFormattedCredits(credit) {
            // format conversion minute string readable
            const addedDot = credit.replace(/(0{3}){0,1}(0{3}){1,}$/, '.$1.$2');

            // remove double dot
            return addedDot.replace(/\.+/, '.');
        },
    },
    data() {
        return {
            selectedCredits: '250',
            isMobile: false,
            learnMore: false,
            selectableCredits: {},
        };
    },
};
</script>
